
/* eslint no-underscore-dangle:  0 */
/* eslint-disable no-debugger, no-console */
/* eslint-disable */
import React from 'react'
import { Box, Button, Modal, TextField, Typography } from '@mui/material'
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import MDTypography from 'components/MDTypography';
import { createTransaction } from 'Redux/actions/transaction';
import { useDispatch } from 'react-redux';
import { getAllTransaction } from 'Redux/actions/transaction';
import { updateTransaction } from 'Redux/actions/transaction';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { sm: '100%', md: '80%', lg: '30%' },
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
};
const AddModal = ({ open, setOpen, formData, setFormData, edit, setEdit }) => {
    const dispatch = useDispatch();
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }
    // console.log(formData)
    const handleAdd = async () => {
        await dispatch(createTransaction(formData));
        await dispatch(getAllTransaction());
        setOpen(false)
    }
    const handleEdit = async () => {
        await dispatch(updateTransaction(formData));
        await dispatch(getAllTransaction());
        setOpen(false)
        setEdit(false)

    }


    return (
        <Modal

            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    {edit ? "Edit" : "Add"} Transaction
                </Typography>
                <TextField id="standard-basic" className="input-field" name="name" onChange={handleChange} value={formData.name} label="Name" variant="standard" required />
                <TextField id="standard-basic" name="amount" onChange={handleChange} value={formData?.amount} label="Amount" variant="standard" required />
                <label style={{ fontSize: "15px", color: "gray" }} htmlFor="">Date</label>
                <DatePicker selected={formData.date} maxDate={new Date()} onChange={(date) => setFormData({ ...formData, date: date })} dateFormat={"dd-MMM-yy"} />
                <br />
                {(!edit) ? <Button variant="contained" color='primary' size="small" onClick={handleAdd}>
                    <MDTypography sx={{ fontSize: "12px" }} color="white">ADD</MDTypography>
                </Button> :
                    <Button variant="contained" color='primary' size="small" onClick={handleEdit}>
                        <MDTypography sx={{ fontSize: "12px" }} color="white">Edit</MDTypography>
                    </Button>
                }
            </Box>
        </Modal>
    )
}

export default AddModal